export default __webpack_public_path__ + "static/media/5.efb4120c.png";